import {SORespIngest} from '../../core/ingest/so-resp-ingest';
import {IngestCore} from './ingest.core';
import {CEBase} from 'lionheartland';
import {EntityViewSpecProtocol} from 'lionheartland';
import { CommanderApp } from "../../land-app";
import {PutIngestFormFields} from './put-ingest-form-fields';
import { CEIngestAttributes } from './ce-ingest-attributes'


export class CEIngestBase extends CEBase {

    public details: CEIngestAttributes;
    public fromFields: PutIngestFormFields = new PutIngestFormFields();

    constructor(
        public parentEntityViewSpec: EntityViewSpecProtocol,
        public core: IngestCore,
        public entity: SORespIngest,
        public app: CommanderApp,
    ) {
        super(
            parentEntityViewSpec, core, entity, app,
        )
        this.details = new CEIngestAttributes(
            parentEntityViewSpec,
            entity,
            app,
            this.fromFields
        );
        this.setAttributes();
        this.sortAttributes();
    }

    setAttributes() {

        this.attributes = []
        this.attributes.push(this.details.entityName)
        this.attributes.push(this.details.data)
        this.attributes.push(this.details.organization)

    }
}